export default __webpack_public_path__ + "static/media/google-cloud-datastore.cf1e6c860f6b78ca7208d71515d7189f.svg";